/* Made in Andhra — theme interactions. Original code. */
(function () {
  'use strict';
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.MIA_CFG || { money: '${{amount}}', freeShip: 0 };
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return (cfg.money || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 400); }

  var lastFocus = null;
  function open(id) {
    var el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input,button,a'); if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function close(el) {
    el = el || $('.m-ov.is-open'); if (!el) return;
    el.classList.remove('is-open');
    if (!$('.m-ov.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-m-open]');
    if (o) { e.preventDefault(); if (o.getAttribute('data-m-open') === 'm-cart') { cart.open(); } else { open(o.getAttribute('data-m-open')); } return; }
    var c = e.target.closest('[data-m-close]');
    if (c) { e.preventDefault(); close(c.closest('.m-ov')); return; }
    var q = e.target.closest('[data-m-qv]');
    if (q) { e.preventDefault(); quickView(q.getAttribute('data-m-qv')); return; }
    var h = e.target.closest('.m-hot>button');
    if (h) { var p = h.parentNode, was = p.classList.contains('is-open'); $$('.m-hot.is-open').forEach(function (x) { x.classList.remove('is-open'); }); if (!was) p.classList.add('is-open'); h.setAttribute('aria-expanded', String(!was)); return; }
    var ar = e.target.closest('[data-m-scroll]');
    if (ar) { var rail = document.getElementById(ar.getAttribute('data-m-target')); if (rail) rail.scrollBy({ left: (ar.getAttribute('data-m-scroll') === 'next' ? 1 : -1) * rail.clientWidth * 0.8, behavior: 'smooth' }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var cart = {
    open: function () { cart.refresh().then(function () { open('m-cart'); }); },
    refresh: function () {
      return fetch(R + 'cart.js').then(function (r) { return r.json(); }).then(cart.render);
    },
    render: function (c) {
      $$('[data-m-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
      var body = $('#m-cart-items'); if (!body) return c;
      var t = $('#m-cart-title'); if (t) t.textContent = 'Your bag (' + c.item_count + ')';
      var sub = $('#m-cart-sub'); if (sub) sub.textContent = money(c.total_price);
      var ship = $('#m-cart-ship');
      if (ship && cfg.freeShip > 0) {
        var left = cfg.freeShip - c.total_price, pct = Math.min(100, Math.round(c.total_price / cfg.freeShip * 100));
        ship.innerHTML = (left > 0 ? 'You’re <b>' + money(left) + '</b> away from free shipping' : '<b>You’ve unlocked free shipping ★</b>') + '<div class="m-ship__bar"><i style="width:' + pct + '%"></i></div>';
        ship.hidden = false;
      }
      if (!c.items.length) { body.innerHTML = '<p style="padding:48px 0;text-align:center;color:var(--m-mu)">Your bag is empty.</p>'; return c; }
      body.innerHTML = c.items.map(function (it, i) {
        var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
        return '<div class="m-line"><a href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a href="' + it.url + '" style="font-weight:600;line-height:1.3;display:block">' + esc(it.product_title) + '</a>' +
          (opts ? '<div style="font-size:13px;color:var(--m-mu)">' + opts + '</div>' : '') +
          '<div class="m-qty"><button type="button" data-m-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-m-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
          '<div style="text-align:right"><b>' + money(it.final_line_price) + '</b><br><button type="button" data-m-line="' + (i + 1) + '" data-q="0" style="background:none;border:0;color:var(--m-mu);font-size:13px;cursor:pointer;margin-top:8px;text-decoration:underline">Remove</button></div></div>';
      }).join('');
      var note = $('#m-cart-note'); if (note && document.activeElement !== note) note.value = c.note || '';
      var gw = $('#m-cart-gift'); if (gw) gw.checked = !!(c.attributes && c.attributes['Gift wrap'] === 'Yes');
      return c;
    },
    change: function (line, q) {
      return fetch(R + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
        .then(function (r) { return r.json(); }).then(cart.render);
    },
    add: function (form) {
      var btn = form.querySelector('[type=submit]'); if (btn) { btn.disabled = true; }
      return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { close($('#m-qv')); cart.open(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to bag'); })
        .then(function () { if (btn) btn.disabled = false; });
    }
  };
  window.MIA = { cart: cart, open: open, close: close };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-m-line]'); if (!b) return;
    cart.change(+b.getAttribute('data-m-line'), +b.getAttribute('data-q'));
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-m-add]'); if (!f) return;
    e.preventDefault(); cart.add(f);
  });
  document.addEventListener('change', function (e) {
    if (e.target.id === 'm-cart-gift') {
      fetch(R + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Gift wrap': e.target.checked ? 'Yes' : '' } }) });
    }
    if (e.target.id === 'm-cart-note') {
      fetch(R + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });

  function quickView(handle) {
    var box = $('#m-qv-body'); if (!box) return;
    box.innerHTML = '<p style="padding:40px">Loading…</p>'; open('m-qv');
    fetch(R + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var pills = p.variants.length > 1 ? '<fieldset class="m-opt"><legend><b>Select</b></legend><div class="m-pills">' + p.variants.map(function (v) {
        return '<label class="m-pill"><input type="radio" name="id" value="' + v.id + '"' + (v.id === first.id ? ' checked' : '') + (v.available ? '' : ' disabled class="is-na"') + '><span>' + esc(v.title) + '</span></label>';
      }).join('') + '</div></fieldset>' : '<input type="hidden" name="id" value="' + first.id + '">';
      box.innerHTML = '<div class="m-modal__img">' + (p.featured_image ? '<img src="' + img(p.featured_image, 900) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
        '<div class="m-modal__body"><button class="m-close m-modal__x" type="button" data-m-close aria-label="Close">✕</button>' +
        '<span class="m-eyebrow"><i class="m-dot"></i>' + esc(p.type || 'Made in Andhra') + '</span><h2 style="font-size:30px;padding-right:48px">' + esc(p.title) + '</h2>' +
        '<div class="m-price">' + money(first.price) + (first.compare_at_price > first.price ? '<s>' + money(first.compare_at_price) + '</s>' : '') + '</div>' +
        '<form data-m-add style="display:flex;flex-direction:column;gap:18px">' + pills +
        '<button class="m-btn m-btn--full" type="submit"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to bag' : 'Sold out') + '</button></form>' +
        '<a class="m-link" href="' + p.url + '">View full details →</a></div>';
    }).catch(function () { box.innerHTML = '<p style="padding:40px">Could not load product.</p>'; });
  }

  var sIn = $('#m-search-q'), sRes = $('#m-search-res'), sT;
  if (sIn && sRes) sIn.addEventListener('input', function () {
    clearTimeout(sT); var q = sIn.value.trim();
    if (q.length < 2) { sRes.innerHTML = ''; return; }
    sT = setTimeout(function () {
      fetch(R + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][prefix]=last')
        .then(function (r) { return r.json(); }).then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          sRes.innerHTML = ps.length ? ps.map(function (p) {
            return '<a class="m-search__item" href="' + p.url + '">' + (p.image ? '<img src="' + img(p.image, 160) + '" alt="">' : '') + '<span><span style="display:block;font-weight:600;font-size:14px;line-height:1.3">' + esc(p.title) + '</span><span style="color:var(--m-mu);font-size:14px">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
          }).join('') : '<p style="color:var(--m-mu)">No products found.</p>';
        });
    }, 220);
  });

  var head = $('.m-head'), top = $('.m-totop');
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (head) head.classList.toggle('is-scrolled', y > 40);
    if (top) top.classList.toggle('is-on', y > 800);
  }, { passive: true });
  if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  $$('[data-m-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-m-countdown')).getTime(); if (isNaN(end)) return;
    function tick() {
      var d = Math.max(0, end - Date.now());
      var parts = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
      $$('b', el).forEach(function (b, i) { b.textContent = String(parts[i]).padStart(2, '0'); });
    }
    tick(); setInterval(tick, 1000);
  });

  var pop = $('#m-pop');
  if (pop && !/challenge|account/.test(location.pathname) && !(window.Shopify && Shopify.designMode)) {
    var seen = false; try { seen = localStorage.getItem('m-pop') === '1'; } catch (e) {}
    if (!seen) setTimeout(function () { if (!$('.m-ov.is-open')) open('m-pop'); try { localStorage.setItem('m-pop', '1'); } catch (e) {} }, (+pop.getAttribute('data-delay') || 10) * 1000);
  }

  var pdp = $('[data-m-pdp]');
  if (pdp) {
    var data = JSON.parse($('#m-pdp-json').textContent);
    var form = $('form[data-m-add]', pdp), idIn = $('input[name=id]', form);
    var mainImg = $('.m-gal__main>img', pdp), thumbs = $$('.m-gal__th button', pdp), cur = 0;
    function show(i) { if (!thumbs.length || !mainImg) return; cur = (i + thumbs.length) % thumbs.length; var t = thumbs[cur]; mainImg.src = t.getAttribute('data-src'); mainImg.removeAttribute('srcset'); thumbs.forEach(function (b) { b.removeAttribute('aria-current'); }); t.setAttribute('aria-current', 'true'); }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    $$('[data-m-gal]', pdp).forEach(function (b) { b.addEventListener('click', function () { show(cur + (+b.getAttribute('data-m-gal'))); }); });
    if (mainImg) mainImg.addEventListener('click', function () { var z = $('#m-zoom-img'); if (z) { z.src = mainImg.src.replace(/width=\d+/, 'width=2000'); open('m-zoom'); } });
    function update() {
      var sel = $$('.m-opt', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
      $$('.m-opt', pdp).forEach(function (fs, oi) {
        var lab = $('[data-m-optval]', fs); if (lab) lab.textContent = sel[oi] || '';
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var ok = data.variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
          inp.classList.toggle('is-na', !ok);
        });
      });
      var btns = $$('[data-m-atc]'), st = $('[data-m-stock]', pdp);
      if (!v) { btns.forEach(function (b) { b.disabled = true; b.firstChild.textContent = 'Unavailable '; }); return; }
      idIn.value = v.id;
      $$('[data-m-price]').forEach(function (p) { p.textContent = money(v.price); });
      var cmp = $('[data-m-compare]', pdp); if (cmp) { cmp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      btns.forEach(function (b) { b.disabled = !v.available; b.firstChild.textContent = v.available ? 'Add to bag ' : 'Sold out '; });
      if (st) {
        var q = data.inv[v.id];
        st.className = 'm-stock' + (!v.available ? ' is-out' : (q != null && q > 0 && q <= 5 ? ' is-low' : ''));
        st.lastChild.textContent = !v.available ? 'Sold out — back soon' : (q != null && q > 0 && q <= 5 ? 'Only ' + q + ' left — order soon' : 'In stock, ready to ship');
      }
      if (v.featured_media_index != null) { var ti = thumbs.findIndex(function (t) { return +t.getAttribute('data-i') === v.featured_media_index; }); if (ti > -1) show(ti); }
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
    $$('.m-opt input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    update();
    $$('[data-m-q]', pdp).forEach(function (b) { b.addEventListener('click', function () { var qi = $('input[name=quantity]', form); qi.value = Math.max(1, Math.min(99, (+qi.value || 1) + (+b.getAttribute('data-m-q')))); }); });
    var sticky = $('.m-sticky'), mainBtn = $('[data-m-atc]', pdp);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(mainBtn);
      $('[data-m-atc]', sticky).addEventListener('click', function () { cart.add(form); });
    }
    try {
      var list = JSON.parse(localStorage.getItem('m-rv') || '[]').filter(function (h) { return h !== data.handle; });
      var rv = $('[data-m-recent]');
      if (rv && list.length) {
        Promise.all(list.slice(0, 4).map(function (h) { return fetch(R + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
          .then(function (ps) {
            ps = ps.filter(Boolean); if (!ps.length) return;
            $('[data-m-recent-grid]', rv).innerHTML = ps.map(function (p) {
              return '<article class="m-card"><a class="m-card__img" href="' + p.url + '">' + (p.featured_image ? '<img src="' + img(p.featured_image, 600) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><div class="m-card__bd"><a class="m-card__t" href="' + p.url + '">' + esc(p.title) + '</a><span class="m-card__p">' + money(p.price) + '</span></div></article>';
            }).join('');
            rv.hidden = false;
          });
      }
      list.unshift(data.handle); localStorage.setItem('m-rv', JSON.stringify(list.slice(0, 10)));
    } catch (e) {}
  }

  var more = $('[data-m-more]');
  if (more) {
    var loading = false;
    var load = function () {
      if (loading || !more.getAttribute('data-next')) return; loading = true; more.textContent = 'Loading…';
      fetch(more.getAttribute('data-next')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('#m-grid>*', doc).forEach(function (c) { $('#m-grid').appendChild(c); });
        var nx = $('[data-m-more]', doc);
        if (nx && nx.getAttribute('data-next')) { more.setAttribute('data-next', nx.getAttribute('data-next')); more.textContent = 'Load more'; loading = false; }
        else { more.parentNode.remove(); }
      });
    };
    more.addEventListener('click', load);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '600px' }).observe(more);
  }

  cart.refresh();
})();
